import { render } from "./TaskWordList.vue?vue&type=template&id=541f6466"
import script from "./TaskWordList.vue?vue&type=script&lang=js"
export * from "./TaskWordList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__